<template>
  <el-row class="warp">
    <el-col :span="12" class="warp-breadcrum">
      <el-breadcrumb separator="/">
        <!-- <el-breadcrumb-item :to="{ path: '/' }">
          <b>首页</b>
        </el-breadcrumb-item> -->
        <el-breadcrumb-item>单篇，整期配置列表</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>

    <!--工具条 begin-->
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item>
            <el-input v-model="formInline.name" placeholder="名称"></el-input>
        </el-form-item>
        <el-form-item>
            <el-button size="mini" type="primary" @click="findTreeData(null)">查询</el-button>
        </el-form-item>
        <el-form-item>
            <el-button size="mini" type="primary" @click="openProcessDialog">新增</el-button>
        </el-form-item>
    </el-form>
    <!--工具条 end-->

    <!-- 列表显示 begin-->
    <el-table :data="partialList" style="width: 100%" stripe border resizable="true">
      <!-- 第一行显示数据 -->
      <el-table-column prop="partialName" label="类型名称" sortable align="center"></el-table-column>
      <el-table-column prop="partialIndex" label="类型编码" sortable align="center"></el-table-column>
      <!-- 操作按钮 -->
      <el-table-column label="操作" style="width: 50%" align="center">
        <template slot-scope="scope">
          <el-button size="mini" @click="showEditDialog(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 列表显示 end-->

    <!--新增对话框界面 begin-->
    <AddPartialDialog ref="addPartialDialog" v-on:signStatusVerdict="listenSignStatus"> </AddPartialDialog>
    <!-- 新增对话框界面 end -->

    <!--编辑对话框界面 begin-->
    <EditPartialDialog ref="editPartialDialog" v-bind:partial="partial" v-on:signStatusVerdict="listenSignStatus"> </EditPartialDialog>
    <!-- 编辑对话框界面 end -->

    <!-- 在此添加新的页面元素 -->
  </el-row>
</template>

<script>
import API_PARTIAL from "../../../api/api_partial";
import AddPartialDialog from "./AddPartial.vue";
import EditPartialDialog from "./EditPartial.vue";

export default {
  data() {
    return {
      formInline:{},

      partial:{},
      partialList:[],
      //在此添加新的数据定义
    };
  },

  components:{
    AddPartialDialog,
    EditPartialDialog,
  },

  methods: {
    //获取出版类型列表
    findAllPartial(){
      let that = this;
      API_PARTIAL.getAllPartial()
      .then(res=>{
        if(res && res.partialConfigs){
          that.partialList = Object.values(res.partialConfigs);
          console.log(
              "......findAllPartial:" + JSON.stringify(that.partialList)
            );
        }
      })
      .catch(e=>{
        this.$message({
          showClose:true,
          type:"error",
          message:"请求出现异常",
          duration:2000
        });
      });
    },

    //通过pubID从后台获取出版类型
    findPartial(_partialId) {
      let that = this;
      let params = {
        partialId: _partialId
      };
      console.log("......findPartial params:" + JSON.stringify(params));
      //发送http请求
      API_PARTIAL.getPartial(params)
        .then(res => {
          if (res) {
            //赋值
            that.partial = res;
            this.$refs.editPartialDialog && this.$refs.editPartialDialog.openDialog(that.partial);
            console.log("......findPartial res:" + JSON.stringify(that.partial));
          }
        })
        .catch(e => {
          this.$message({
            showClose: true,
            type: "error",
            message: "请求出现异常",
            duration: 2000
          });
        });
    },

    //显示新建对话框
    openProcessDialog() {
        this.$refs.addPartialDialog && this.$refs.addPartialDialog.openDialog();
    },

    //显示编辑对话框
    showEditDialog: function(index, row) {
        let that = this;
        that.findPartial(row.partialId);
        setTimeout(() => {     
        }, 500);
    },

    //删除操作
   handleDelete: function(index, row) {
      let that = this;
      that
        .$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          let params = {
            partialId: row.partialId
          };

          console.log(".........partialDelete params:" + JSON.stringify(params));
          //调用post请求，进行删除
          API_PARTIAL.delete(params)
            .then(res => {
              console.log(res);
              if (0 === res.errorCode) {
                that.$message({
                  type: "success",
                  message: "删除成功!"
                });

                //更新列表
                that.findAllPartial();
              } else {
                that.$message({
                  showClose: true,
                  message: res.errorInfo,
                  type: "error"
                });
              }
            })
            .catch(e => {
              that.$message({
                showClose: true,
                type: "error",
                message: "请求出现异常",
                duration: 2000
              });
            });
        })
        .catch(() => {
          that.$message({
            type: "info",
            message: "取消删除"
          });
        });
    },
    listenSignStatus: function(signStatus){
        this.findAllPartial();
    },
  },
  mounted() {
    this.findAllPartial();
  }
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/SysMng/Partial/PartialManage.vue